import React, { useRef } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import HeroSection from './components/HeroSection'; 
import ServicesSection from './components/ServicesSection';
import Header from './components/Header';
import DetailedSections from './components/DetailedSections';

import AboutUs from './components/AboutUs';
import WhyChooseUs from './components/WhyChooseUs';
import Documentation from './components/Documentation';
import OpenRoles from './components/OpenRoles';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

// Main page
function Page() {
  const hftRef = useRef<HTMLDivElement | null>(null);
  const mlRef = useRef<HTMLDivElement | null>(null);
  const caRef = useRef<HTMLDivElement | null>(null);
  const contactRef = useRef<HTMLDivElement | null>(null);
  const openRolesRef = useRef<HTMLDivElement | null>(null);

  const scrollToRef = (ref: React.RefObject<HTMLDivElement>) => {
    ref.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="flex min-h-screen flex-col">
      <Header
        scrollToRef={scrollToRef}
        contactRef={contactRef}
        openRolesRef={openRolesRef}
      />

      <main className="flex-1">
        <div className="bg-gray-100">
          <HeroSection />
        </div>

        <div className="bg-white flex items-center justify-center">
          <ServicesSection
            scrollToRef={scrollToRef}
            refs={{ hftRef, mlRef, caRef }}
          />
        </div>

        <div className="bg-gray-100">
          <DetailedSections hftRef={hftRef} mlRef={mlRef} caRef={caRef} />
        </div>

        <div className="bg-white">
          <AboutUs />
        </div>

        <div className="bg-gray-100">
          <WhyChooseUs />
        </div>

        <div className="bg-white">
          <Documentation />
        </div>

        <div className="bg-gray-100">
          <OpenRoles ref={openRolesRef} />
        </div>

        <div className="bg-white-100">
          <ContactSection contactRef={contactRef} />
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <Page />
    </Router>
  );
}